import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { string, ObjectSchema, object, number } from "yup";
import { ClerkListResponse } from '../../models/clerks';


export type AdminEditClerkFormValues = {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
	county: string;
	municipality: string;
	streetAddress: string;
	aptSuiteBuilding: string;
	city: string;
	state: number;
	zipCode: string;
};

export const editClerkValidationSchemaBase = {
	firstName: string().required("First name field is required"),
	lastName: string().required("Last name field is required"),
	phone: string()
		.required("Phone field is required")
		.matches(
			/^\+?(1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\\-]?[0-9]{3}[\s\\-]?[0-9]{4}$/,
			"Phone number is invalid"
		),
	email: string()
		.email("Please enter a valid email")
		.required("Email field is required"),
	county: string().required("County field is required"),
	municipality: string().required("Municipality field is required"),
	streetAddress: string().required("Street address field is required"),
	aptSuiteBuilding: string().required(),
	city: string().required("City field is required"),
	state: number()
		.typeError("State field is required")
		.required("State field is required"),
	zipCode: string()
		.required("Zip code field is required")
		.matches(/^[0-9]+$/, "Must be only digits")
		.min(5, "Must be exactly 5 digits")
		.max(5, "Must be exactly 5 digits"),
};

const editAccountValidationSchema: ObjectSchema<AdminEditClerkFormValues> = object({
		...editClerkValidationSchemaBase
	})
	.required();

export function useAdminEditClerkForm(account?: ClerkListResponse) {
	return useForm<AdminEditClerkFormValues>({
		resolver: yupResolver(editAccountValidationSchema),
		reValidateMode: "onChange",
		defaultValues: {
			firstName: account?.firstName,
			lastName: account?.lastName,
			email: account?.email,
			phone: account?.phone,
			county: account?.county,
			municipality: account?.municipality,
			streetAddress: account?.address1,
			aptSuiteBuilding: account?.address2,
			city: account?.city,
			state: account?.state.id,
			zipCode: account?.postalCode,
		},
	});
}
